import { CareersMap } from "./careersAction";

const initialState = {
  isLoading: false,
  careersList: [],
  careers: [],
  categoryList: [],
  categoryListLoading: false,
  refreshCareers: true,
  selectedCareers: {},
  reDirect: false,
  searchBy: "",
  searchText: "",
  skip: 0,
  limit: 10,
  isLogsLoading: false,
  logCareers: {},
  careersLogs: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CareersMap.CREATE_CAREERS_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersMap.CREATE_CAREERS_SUCCESS: {
      return {
        ...state,
        refreshCareers: true,
        reDirect: true,
      };
    }
    case CareersMap.CREATE_CAREERS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case CareersMap.GET_ALL_CAREERS_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersMap.GET_ALL_CAREERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshCareers: false,
        careersList: action.payload,
      };
    }
    case CareersMap.GET_ALL_CAREERS_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshCareers: false,
      };
    }
    case CareersMap.UPDATE_CAREERS_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersMap.UPDATE_CAREERS_SUCCESS: {
      return {
        ...state,
        refreshCareers: true,
        selectedCareers: {
          ...state.selectedCareers,
          ...action.payload,
        },
        reDirect: true,
      };
    }
    case CareersMap.UPDATE_CAREERS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case CareersMap.DELETE_CAREERS_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersMap.DELETE_CAREERS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshCareers: true,
      };
    }
    case CareersMap.DELETE_CAREERS_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case CareersMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case CareersMap.REFRESH_CAREERS_LIST: {
      return {
        ...state,
        skip: 0,
        refreshCareers: true,
      };
    }
    case CareersMap.GET_CAREERS_DETAIL_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case CareersMap.GET_CAREERS_DETAIL_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedCareers: action.payload,
        refreshCareers: false,
      };
    }
    case CareersMap.GET_CAREERS_DETAIL_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshCareers: false,
      };
    }
    case CareersMap.GET_CAREERS_LIST_START: {
      return {
        ...state,
      };
    }
    case CareersMap.GET_CAREERS_LIST_SUCCESS: {
      return {
        ...state,
        careers: action.payload,
      };
    }
    case CareersMap.GET_CAREERS_LIST_ERROR: {
      return {
        ...state,
      };
    }
    case CareersMap.SET_CAREERS_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshCareers: true,
      };
    }
    case CareersMap.GET_WEB_CAREERS_CIYT_LIST_LOADING:
      return {
        ...state,
        categoryListLoading: true,
      };

    case CareersMap.GET_WEB_CAREERS_CIYT_LIST_SUCCESS:
      return {
        ...state,
        categoryList: action.payload,
        categoryListLoading: false,
      };

    case CareersMap.GET_WEB_CAREERS_CIYT_LIST_ERROR:
      return {
        ...state,
        categoryListLoading: false,
      };
    case CareersMap.GET_WEBCLUES_CAREERS_LOGS_START: {
      return {
        ...state,
        isLogsLoading: true,
        logCareers: {},
        careersLogs: [],
      };
    }
    case CareersMap.GET_WEBCLUES_CAREERS_LOGS_SUCCESS: {
      return {
        ...state,
        isLogsLoading: false,
        logCareers: action.payload?.careers || {},
        careersLogs: action.payload?.logs || [],
      };
    }
    case CareersMap.GET_WEBCLUES_CAREERS_LOGS_ERROR: {
      return {
        ...state,
        isLogsLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
